import { Injectable, Signal, WritableSignal, computed, signal } from '@angular/core';
import { Store } from '@ngxs/store';
import { listLocales } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Culture, cultures } from '../models/culture.mode';
import { MainState, SetSelectedLanguage } from '../stores/main.store';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  currentLanguageSignal: Signal<string>;
  dateFormat: string = 'DD-MM-YYYY';
  decimalSeperator: string = ',';
  thousandSeparator: string = '.';
  pageLanguage: WritableSignal<string | null>;

  constructor(private bsLocaleService: BsLocaleService, private store: Store) {
    this.pageLanguage = signal(null);
    this.currentLanguageSignal = computed(
      () =>
        this.pageLanguage() ||
        this.store.selectSignal(MainState.selectedLanguage)() ||
        this.store.selectSignal(MainState.defaultLanguage)()
    );

    this.bsLocaleService.use(this.currentLanguageSignal());
    this.bsLocaleService.localeChange.subscribe((locale) => {
      if (locale) {
        this.getDateFormat(locale);
      }
    });
  }

  currentLanguage(): string {
    return this.currentLanguageSignal();
  }

  listLanguages(): string[] {
    return cultures.map((c) => c.language);
  }

  applyLocale(locale: string | null) {
    if (locale) {
      const locales = listLocales();
      if (locales.includes(locale)) {
        this.bsLocaleService.use(locale);
      }
    }
  }

  updatePageLocale(locale: string | null) {
    if (locale) {
      locale = locale.split('-')[0];
      this.pageLanguage.set(locale);
      this.applyLocale(locale);
    } else {
      this.pageLanguage.set(null);
    }
  }

  updateLocale(locale: string) {
    this.store.dispatch(new SetSelectedLanguage(locale));
    this.applyLocale(locale);
  }

  getDateFormat(locale: string) {
    switch (locale) {
      case 'da':
        this.dateFormat = 'DD-MM-YYYY';
        this.decimalSeperator = ',';
        this.thousandSeparator = '.';
        break;
      case 'en':
        this.dateFormat = 'MM/DD/YYYY';
        this.decimalSeperator = '.';
        this.thousandSeparator = ',';
        break;
      case 'de':
        this.dateFormat = 'DD.MM.YYYY';
        this.decimalSeperator = ',';
        this.thousandSeparator = '.';
        break;
      case 'fr':
        this.dateFormat = 'DD/MM/YYYY';
        this.decimalSeperator = ',';
        this.thousandSeparator = '.';
        break;
      case 'nl':
        this.dateFormat = 'DD-MM-YYYY';
        this.decimalSeperator = ',';
        this.thousandSeparator = '.';
        break;
      case 'nb':
        this.dateFormat = 'DD.MM.YYYY';
        this.decimalSeperator = ',';
        this.thousandSeparator = ' ';
        break;
      case 'sv':
        this.dateFormat = 'YYYY-MM-DD';
        this.decimalSeperator = ',';
        this.thousandSeparator = ' ';
        break;

      default:
        break;
    }
  }
}
